import React, { useState } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
import useModal from "../../utils/useModal";
import ConfirmationModal from "../../components/confirmation-modal/confirmation-modal.component";
import ActionFeedbackModal from "../../components/action-feedback-modal/action-feedback-modal.component";
import ImportOfSummariesModal from "../../components/import-of-summaries-modal/import-of-summaries-modal.component";

import API_ROUTE from "../../utils/apiRoute";

const ImportOfSummaries = () => {
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  const [isActionCompleted, setIsActionCompleted] = useState(false);

  const {
    isShowing: isShowingDeleteReservationModal,
    toggle: toggleDeleteReservationModal,
  } = useModal();

  const {
    isShowing: isShowingConfirmationModal,
    toggle: toggleConfirmationModal,
  } = useModal();

  const {
    isShowing: isShowingFeedbackModal,
    toggle: toggleFeedbackModal,
  } = useModal();

  const importFromSummaries = () => {
    (async () => {
      await axios
        .get(`${API_ROUTE}reservation/importFromSummaries`, {
          withCredentials: true,
          params: {
            dateStart,
            dateEnd,
          },
        })
        .then((res) => {
          toggleConfirmationModal();
          toggleDeleteReservationModal();
          setIsActionCompleted(true);
          toggleFeedbackModal();
        })
        .catch((err) => {
          setIsActionCompleted(false);
          console.error(err.response);
        });
    })();
  };

  return (
    <div>
      <Button
        variant="outline-info"
        style={{ marginTop: "10%" }}
        onClick={toggleDeleteReservationModal}
      >
        Importar Reservas do Sumários
      </Button>
      <ImportOfSummariesModal
        toggle={toggleDeleteReservationModal}
        isShowing={isShowingDeleteReservationModal}
        toggleConfirmationModal={toggleConfirmationModal}
        dateStart={dateStart}
        dateEnd={dateEnd}
        setDateStart={setDateStart}
        setDateEnd={setDateEnd}
      />
      <ConfirmationModal
        isShowing={isShowingConfirmationModal}
        toggle={toggleConfirmationModal}
        handleConfirmation={importFromSummaries}
        titleText={"Importar do Sumários"}
      />

      <ActionFeedbackModal
        isShowing={isShowingFeedbackModal}
        toggle={toggleFeedbackModal}
        isActionCompleted={isActionCompleted}
        titleText={"Processo de Importação Iniciado com Sucesso!"}
      />
    </div>
  );
};

export default ImportOfSummaries;
